import { validateBin, validateOrderReferenceNumber } from "./validationEngine.js";
import * as ErrorCodes from "./validationErrorCodes";

// StockOrder Bin Validation
export const binValidationBodyData = (binData) => {

    let result;
    let invalidCharacters;
    let bin;

    if (binData.type === "StockOrder") bin = binData.binTextForModal;
    if (binData.type === "AddItem" || binData.type === "BinEntry") bin = binData.newValue;
    if (binData.type === "BulkUpload") bin = binData.row[binData.bulkUploadBinColumn];

    let obj = {
        sBin: bin
    }

    result = validateBin(obj);
    if (result.result != ErrorCodes.RC_SUCCESS) {
        invalidCharacters = result.reason;
        for (var i = 0; i < invalidCharacters.length; i++) {
            bin = bin.replace(invalidCharacters[i], "");
        }
    }

    if (binData.type === "StockOrder") {
        let part = binData.orderLines.find(e => e.inventorySkuPK === binData.inventorySKUPKForModal);
        let partNumber = "";
        let binModalTopText = binData.pageText.stockOrderBinValidationModalBodyText1;
        let binModalBottomText = binData.pageText.stockOrderBinValidationModalBodyText3;

        if (part) {
            partNumber = part.partNumber;
        }
        binModalTopText = binModalTopText.replace("%%BINTEXT%%", binData.binTextForModal);
        binModalTopText = binModalTopText.replace("%%PARTNUMBER%%", partNumber);

        binModalBottomText = binModalBottomText.replace("%%INVALIDCHARACTERS%%", invalidCharacters);

        let data = {
            binModalTopText: binModalTopText,
            binModalBottomText: binModalBottomText
        }
        return data;
    }

    // AddItem Bin Validation
    if (binData.type === "AddItem" || binData.type === "BinEntry") {
        return { invalidCharacters, newValueData: bin };
    }

      // BulkUpload Bin Validation
    if (binData.type === "BulkUpload") {
        if (result.result != ErrorCodes.RC_SUCCESS) {
            binData.specialCharatersInBinParts.push({
                partNumber: binData.row[binData.bulkUploadPartColumn].toString(),
                bin: binData.row[binData.bulkUploadBinColumn]
            });
            binData.row[binData.bulkUploadBinColumn] = bin;
        }

        return binData.row[binData.bulkUploadBinColumn]
    }
}

// StockOrder Qty Validation
export const qtyValidationData = (pageText, qtyValue) => {
    let text = pageText.stockOrderQtyGreaterThanFiftyModalText;
    text = text.replace("%%QTYVALUE%%", qtyValue);
    return text;
}